import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ShebaSkipToMainContentComponent } from 'app/core/components/skip-to-main-content/skip-to-main-content.component';
import { LoaderService } from 'app/core/services/loader.service';
import { ShebaFooterComponent } from '../../core/components/footer/footer.component';
import { ShebaHeaderComponent } from '../../core/components/header/header.component';
import { LoaderComponent } from '../../core/components/loader/loader.component';
import { SharedService } from '../../core/services/shared.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'sheba-layout',
  templateUrl: './sheba-layout.component.html',
  styleUrl: './sheba-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  imports: [ShebaHeaderComponent, ShebaFooterComponent, RouterOutlet, LoaderComponent, ShebaSkipToMainContentComponent]
})
export class ShebaLayoutComponent {
  readonly sharedService = inject(SharedService);
  readonly loaderService = inject(LoaderService);
  readonly translate = inject(TranslateService);
  lightMode = this.sharedService.lightMode;

  translationsLoaded = signal(false);

ngOnInit() {
  this.translate.use(this.translate.currentLang || this.translate.defaultLang)
    .subscribe(() => {
      this.translationsLoaded.set(true);
    });
}
}
